import React from "react";
import img from "../assets/Logo.jpeg";
import "./style.css";

function Privacy() {
  return (
    <>
      <div className="backgroundPrivacy">
        <div className="document">
          <div className="subtitlePrivacy">
            <img
              src={img}
              className="imgSubtitle"
              alt="ATDB Anpo Tecnologia do Brasil / Rua Maranhão, 575 - Sala 1014 - Praia da Costa / Centro Empresarial Torre Sul - Vila Velha - ES / Tel. 27 3299 6522 - Cnpj: 21 318 943/0001-37"
            />
          </div>
          <div className="textPrivacy">
            <h3>TERMOS E POLÍTICA DE PRIVACIDADE</h3>
            <p>
              Por este instrumento eletrônico, Giwama, (CLICKLOJA), pessoa jurídica de direito privado com 
              sede na Rua Maranhão, 10 - Praia da Costa, Vila Velha, ES, CEP 29101-340, doravante, 
              “APLICATIVO CLICKLOJA”, informa sua POLÍTICA DE PRIVACIDADE, conforme as disposições abaixo discriminadas:
            </p>
            <h4>Noções gerais :</h4>
            <p>
              Este instrumento traz a política de privacidade dos serviços prestados pela CLICKLOJA, mostrando 
              a forma como os dados e informações pessoais de cada USUÁRIO serão administrados pelo APLICATIVO CLICKLOJA.
            </p>
            <p>
              O APLICATIVO CLICKLOJA, obtém informações dos USUÁRIOS, apenas através de cadastros devidamente preenchidos pelos próprios usuários. 
              Exemplo: Cadastro – informações e dados.
            </p>
            <p>
              Para usufruir dos serviços do APLICATIVO CLICKLOJA, é necessário cadastro, no qual haverá o fornecimento de alguns dados pessoais, 
              os quais serão usados como forma de registro pelo APLICATIVO CLICKLOJA.
            </p>
            <p>
              Poderão ser coletados os seguintes dados pessoais, cuja veracidade é de única e exclusiva responsabilidade do USUÁRIO:
            </p>
            <ul>
              <li>Nome Completo</li>
              <li>Estado, Cidade e Bairro</li>
              <li>Login e senha</li>
              <li>Número de celular do usuário</li>
            </ul>
            <p>
              O APLICATVO CLICKLOJA, não coleta e armazena informações sobre a atividade dos usuários cadastrados e visitantes de seu 
              aplicativo, ou seja, o APLICATIVO CLICKLOJA não inclui a URL de onde eles provêm (seja ela dá próprio do APLICATIVO CLICKLOJA ou não), 
              a que URL acessaram em seguida (seja ela do APICATIVO CLICKLOJA ou não), o navegador que estão a utilizar e seus IPs de acesso, 
              as páginas visitadas, as buscas realizadas, dentre outras informações, não serão armazenadas e retidas.
            </p>
            <h4>Do atendimento ao usuario: </h4>
            <p>
              Os contatos efetuados pelo USUÁRIO com o APLICATIVO CLICKLOJA pelos canais de atendimento, não serão gravados em hipótese alguma.
            </p>
            <h4>Segurança de informações : </h4>
            <p>
              A política de privacidade do APLICATIVO CLICKLOJA, visa garantir que quaisquer informações e dados dos usuários não serão fornecidos, 
              publicados ou comercializados em quaisquer circunstâncias. Os dados pessoais informados ao APLICATIVO CLICKLOJA, são armazenados em um 
              banco de dados reservado e com acesso restrito ao APLICATIVO CLICKLOJA, que se obriga, por contrato, a manter a confidencialidade das 
              informações e não utilizá-las inadequadamente.
            </p>
            <h4>Senha :</h4>
            <p>
              Para acesso dos serviços reservados unicamente aos utilizadores devidamente registrados, estes irão dispor de uma senha pessoal. 
              Esta senha, que é escolhida pelo próprio USUÁRIO, deve ser mantida sob absoluta confidencialidade e, em nenhum caso, deverá ser revelada 
              ou compartilhada com outras pessoas.
            </p>
            <h4>Alterações da Politica de Privacidade : </h4>
            <p>
              O APLICATIVO CLICKLOJA se reserva o direito de alterar esta Política a qualquer tempo, com ou sem aviso prévio. No entanto, 
              se esta Política for alterada haverá um novo aceite do USUÁRIO, garantindo a total transparência do nosso sistema.
            </p>
            <p>
              A ACEITAÇÃO DESTES TERMOS E CONDIÇÕES GERAIS, SE DÁ DE FORMA AUTOMÁTICA NO MOMENTO QUE O USUÁRIO EFETUA SEU CADASTRO NO APLICATIVO CLICKLOJA. 
              O USUÁRIO deverá ler, certificar-se de haver entendido as disposições estabelecidas nos Termos e Condições gerais e na Política de 
              Privacidade do APLICATIVO CLICK LOJA.
            </p>
            <h4>Do usuario :</h4>
            <p>
              Os serviços do APLICATIVO CLICKLOJA, somente estão disponíveis para as pessoas que tenham plena capacidade civil para contratar. 
              Dessa forma, não podem efetuar cadastro pessoas menores de 18 anos ou acometidas por outras incapacidades 
              inscritas nos artigos 3º e 4º do Código Civil Brasileiro, salvo se devidamente representadas ou assistidas.
            </p>
            <p>
              O USUÁRIO se compromete a fornecer seus dados pessoais de forma
              verdadeira e precisa, devendo atualizá-los sempre que ocorrer
              alguma alteração.
            </p>
            <p>
              O APLICATIVO CLICKLOJA não se responsabiliza pela veracidade das
              informações prestadas por seus USUÁRIOS, sendo deles toda a
              responsabilidade por seu conteúdo.
            </p>
            <p>
              O APLICATIVO CLICKLOJA poderá checar a veracidade dos dados
              cadastrais de todos os USUÁRIOS a qualquer tempo. Caso constate haver
              entre eles dados incorretos ou inverídicos, ou ainda, caso o
              USUÁRIO se furte ou se negue a enviar os dados cadastrais, o
              APLICATIVO CLICKLOJA poderá bloquear o perfil do USUÁRIO, até que
              a irregularidade seja sanada.
            </p>
            <p>
              O USUÁRIO acessará sua conta através de login e senha, sendo de
              sua inteira responsabilidade a guarda dos mesmos.
            </p>
            <p>
              O USUÁRIO compromete-se a notificar o APLICATIVO CLICKLOJA
              imediatamente, através de comunicação em que fique certificado o
              recebimento do APLICATIVO
            </p>
            <p>
              O login que o USUÁRIO utilizará no APLICATIVO CLICKLOJA, será
              sempre o número do celular cadastrado no APLICATIVO CLICKLOJA.
            </p>
            <p>
              O login que o USUÁRIO utiliza na CLICKLOJA será automaticamente
              cancelado, por falta de utilização por mais de 180 (cento e
              oitenta dias), por motivo de inatividade. Caso o USUÁRIO desejar
              ter acesso ao aplicativo novamente, será necessário realizar novo
              cadastro para ter acesso ao conteúdo do APLICATIVO CLICKLOJA.
            </p>
            <h4>DO SERVIÇO PRESTADO : </h4>
            <p>
              O APLICATIVO CLICKLOJA possui como objetivo, fornecer as lojas
              parceiras, ferramentas para conhecer, cadastrar, informar
              promoções, apresentar campanhas de fidelidade, promover sorteios e
              agradecer seus clientes, de forma que as lojas terão acesso apenas
              aos dados dos seus respectivos clientes.
            </p>
            <p>
              Lojas parceiras do APLICATIVO CLICKLOJA, poderão acessar os dados
              dos USUÁRIOS através do APLICATIVO CLICKLOJA, ou através de
              leitura de QR CODE dos cupons fiscais, para que sejam
              disponibilizados aos seus USUÁRIOS, promoções, sorteios, campanha
              de fidelidade, ou qualquer outro benefício que interesse ao
              USUÁRIO do APLICATIVO CLICK LOJA.
            </p>
            <p>
              O APLICATIVO CLICKLOJA, manterá gravado em seu banco de dados, os
              produtos adquiridos por seus USUÁRIOS, para melhor direcionamento
              de promoções das lojas parceiras, aos USUÁRIOS do APLICATIVO
              CLICKLOJA.
            </p>
            <p>
              O APLICATIVO CLICKLOJA dispõe de uma ferramenta de controle
              financeiro, que somente o USUÁRIO do APLICATIVO CLICKLOJA terá
              acesso, sendo vedado o uso por lojas parceiras
            </p>
            <p>
              A qualquer momento o APLICATIVO CLICKLOJA poderá, a seu exclusivo
              critério, suspender ou interromper por prazo indeterminado os
              serviços prestados ao USUÁRIO, em casos de suspeita de cometimento
              de fraudes ao consumidor, fundamentada por denúncias de qualquer
              tipo, notificações judiciais e/ou extrajudiciais, citações em
              processos de responsabilidade a qualquer título.
            </p>
            <p>
              Caso sejam detectados acessos robóticos e/ou ilegais na loja
              virtual do USUÁRIO, O APLICATIVO CLICKLOJA poderá bloquear
              imediatamente a loja por tempo indeterminado por medidas de
              segurança.
            </p>
            <p>
              O APLICATIVO CLICKLOJA não se responsabiliza por qualquer dano,
              prejuízo ou perda sofridos pelo USUÁRIO em razão de falhas na
              internet, no sistema ou no servidor utilizados pelo USUÁRIO,
              decorrentes de condutas de terceiros, caso fortuito ou força
              maior.
            </p>
            <p>
              O APLICATIVO CLICKLOJA se compromete a prestar auxílio pelos
              serviços oferecidos por seu aplicativo, não oferecendo suporte a
              quaisquer produtos adquiridos em outras empresas, não assumindo
              prejuízo algum devido à impossibilidade de instalação ou danos a
              loja, devido à utilização incorreta de códigos oferecido por
              terceiros.
            </p>
            <p>
              O APLICATIVO CLICKLOJA não interfere em comercializações feitas
              por LOJAS PARCEIRAS e USUÁRIOS, ficando sua responsabilidade
              restrita ao desenvolvimento funcional do aplicativo.
            </p>
            <h4>DAS DISPOSIÇOES FINAIS :</h4>
            <p>
              Estes Termos e Condições Gerais não geram nenhum contrato de
              sociedade, de mandato, franquia ou relação de trabalho entre o
              APLICATIVO CLICKLOJA e o USUÁRIO. O USUÁRIO manifesta ciência de
              que o APLICIATIVO CLICKLOJA não é parte de nenhuma transação
              realizada entre USUÁRIOS, nem possui controle algum sobre a
              qualidade, segurança ou legalidade dos produtos ou serviços
              anunciados pelas LOJAS PARCEIRAS, bem como a veracidade ou
              exatidão dos anúncios elaborados pelas LOJAS PARCEIRAS, e sobre a
              capacidade dos USUÁRIOS para negociar.
            </p>
            <p>
              O conteúdo deste instrumento poderá ser modificado livremente pelo
              APLICATIVO CLICKLOJA por meio de comunicação eletrônica aos
              USUÁRIOS, passando os novos termos a valer desde a data em que
              forem veiculados no APLICATIVO CLICKLOJA, reservando-se ao USUÁRIO
              o direito de permanecer cadastrado ou simplesmente solicitar sua
              exclusão
            </p>
            <p>
              Todo o conteúdo, tais como, textos, programas de computador, sons,
              fotografias e outros materiais disponíveis no APLICATIVO CLICKLOJA
              marcas, patentes, modelos, desenhos industriais, a aparência, a
              organização e a estrutura do APLICATIVO CLICKLOJA, são protegidas
              pela legislação de propriedade intelectual aplicável e não
              infringem qualquer lei ou norma a que estejam subordinadas,
              contratos, documentos, acordos dos quais faz parte, bem como não
              infringe direitos de terceiros. A violação de tais direitos
              ensejará a respectiva reparação integral dos danos aos
              prejudicados, seja o APLICATIVO CLICKLOJA, seus USUÁRIOS e/ou
              terceiros
            </p>
            <p>
              É vedado ao USUÁRIO modificar, copiar, distribuir, transmitir,
              exibir, realizar, reproduzir, publicar, disponibilizar, licenciar
              ou criar obras derivadas a partir das informações coletadas no
              APLICATIVO CLICKLOJA, bem como transferir ou vender tais
              informações, software, produtos ou serviços, sob pena de violação
              do presente termo e infração legal
            </p>
            <p>
              Fica eleito, para dirimir eventuais dúvidas e resolver os
              conflitos oriundos deste contrato, o foro da Cidade de Vila Velha,
              Estado do Espírito Santo, com renúncia a qualquer outro, por mais
              privilegiado que seja salvo os USUÁRIOS que se enquadrem no
              conceito legal de consumidor e optem pela prerrogativa legal.
            </p>
            <p>
              Os casos omissos neste instrumento serão resolvidos de
              conformidade com as disposições legais aplicáveis à espécie.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Privacy;
